import React from 'react';

import TextField from 'material-ui/TextField';
import { FormHelperText } from 'material-ui/Form';

const errorText = {
    display: 'flex',
    justifyContent: 'center',
    color: 'red'
};

const divStyle = {
    marginTop: '3.2%'
};

const renderDatePicker = ({ input, label, className, divClassName, password, disabled, meta: { touched, error }, ...custom }) => (
    <div className={divClassName} style={divStyle}>
        <TextField
            label={label}
            error={(touched && error && error !== '')}
            type="date"
            disabled={disabled}
            className={className}
            {...input}
            {...custom}
            InputLabelProps={{
                shrink: true,
            }}
        />
        {
            touched && error &&
            <FormHelperText style={errorText}>{error}</FormHelperText>
        }
    </div>
);

export default renderDatePicker;


// WEBPACK FOOTER //
// ./src/helpers/RenderDatePicker.js